/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */


import PageContentContainer from "../../Container/PageContentContainer";
import ExternalInvoice from "../../ExternalInvoice/ExternalInvoice";
import PageHeadline from "../../PageHeadline/PageHeadline";

const ExternalInvoicePage = () => {
  return (
    <PageContentContainer size="tiny">
      <PageHeadline main="Externe Rechnungen erstellen" />
        <ExternalInvoice />
    </PageContentContainer>
  );
};

export default ExternalInvoicePage;
